export const BACKEND =
  (process.env.REACT_APP_CMS_URL ?? "https://090101.cms.wicode.io") + "/api";
export const IMG_CMS =
  process.env.REACT_APP_CMS_URL ?? "https://090101.cms.wicode.io";

export const CDS_URL = process.env.REACT_APP_MAIL_URL
export const CDS_API_KEY = process.env.REACT_APP_MAIL_KEY